import React from 'react';
import { PropTypes as PT } from 'prop-types';
import SearchDropdownComp from 'components/SearchDropdown/SearchDropdown';
import ChatSearchBar from 'components/Chat/Search/ChatSearchBar';
import ChatSearchResults from 'components/Chat/Search/ChatSearchResults';

class ChatSearch extends React.PureComponent {
  constructor(props) {
    super(props);
    this.isFocused = this.isFocused.bind(this);
  }

  isFocused() {
    return (
      this.props.isFocused &&
    this.props.searchString &&
    !!this.props.searchString.length
    );
  }

  render() {
    return (
      <SearchDropdownComp
        buttonComponent={<ChatSearchBar {...this.props} />}
        menuComponent={
          <ChatSearchResults
            {...this.props}
            selectContactHandler={this.props.onSelectContact}
          />
        }
        isVisible={this.isFocused()}
        clickOutsideHandler={this.props.handleSetIsFocused}
        maxItems={this.props.maxItems}
      />
    );
  }
}

ChatSearch.propTypes = {
  handleSetIsFocused: PT.func.isRequired,
  isFocused: PT.bool.isRequired,
  maxItems: PT.number.isRequired,
  searchString: PT.string,
  onSelectContact: PT.func.isRequired
};

export default ChatSearch;
